import RoutesMap from "../../route_control/RouteControl"
import { Dashboard, StudentDashboard } from "../../pages/dashboard"
import { isStudent } from "../../utils"

export const DashboardRouteImport = {
    RoutesMap,
    Dashboard,
    StudentDashboard,
    isStudent
}
